module.exports = __webpack_public_path__ + "img/map-location.740f2d08.svg";